module.exports = __webpack_public_path__ + "static/media/logoWhite.8fef895d.svg";